module.exports = __webpack_public_path__ + "static/media/twitter.e114665f.svg";